import { render } from "./Vorsorgeaufstellung.vue?vue&type=template&id=e70ba326"
import script from "./Vorsorgeaufstellung.vue?vue&type=script&lang=js"
export * from "./Vorsorgeaufstellung.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__